import { mediaItems } from '@/mocks/homeData';

export default function Media() {
  return (
    <section id="media" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精彩集锦</h2>
          <p className="text-sm text-foreground-500">幕后花絮与深度解读</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a key={item.id} href="#media" className="group block bg-background-50 rounded-lg overflow-hidden cursor-pointer">
              <div className="relative w-full h-[180px] md:h-[200px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-200"></div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/60 rounded text-xs text-white font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center transition-transform duration-200 group-hover:scale-110">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <div className="text-xs text-primary-600 font-medium mb-1.5">{item.category}</div>
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}